import { Route, Router, Routes } from "react-router-dom";
import Login from "../pages/Login/Login";
import StaffManagement from "../pages/StaffManagement/StaffManagement";
import Profile from "../pages/MyProfile/MyProfile";
import AddFuelDetails from "../pages/FuelManagement/AddFuel/AddFuelDetails";
import TrackVehicle from "../pages/StaffManagement/TrackVehicle1/TrackVehicle";
import TrackFuel from "../pages/FuelManagement/TrackFuel/TrackFuel";
import StaffManagement2 from "../pages/StaffManagement2/StaffManagement2";
import TrackFuelPUrchase from "../pages/FuelManagement/ViewFuelPurchase/ViewFuelPurchase";
import ForgetPassword from "../pages/ForgotPass/ForgetPassword";
import AddMaintenance from "../pages/Maintainance/AddMaintenance/AddMaintenance";
import TrackMaintenance from "../pages/Maintainance/viewMaintenance/viewMaintenance";
import EditDetails from "../pages/StaffManagement/EditTripDetails/EditDetails";
import UpdateTripDetails from "../pages/StaffManagement/UpdateTripDetails/UpdateTripDetails";
import EditMaintenance from "../pages/Maintainance/EditMaintenance/EditMaintenance";
import AddVehicleComponent from "../pages/VehicleManagement/AddVehicle/AddVehicle";
import AddVendorComponent from "../pages/VendorManagement/AddVendor/AddVendor";
import AddDriverManagement from "../pages/DriverManagement/AddDriver/AddDriver";
import ViewVehicleComponent from "../pages/VehicleManagement/ViewVehicle/ViewVehicle";
import PrivacyPolicy from "../components/common/PrivacyPolicy";
import DashboardMain from "../components/Dashboard/DashboardMain";
import ReportTabularView from "../components/Dashboard/ReportTabularView";

export default function index() {
  return (
    <>
      {localStorage.getItem("token") ? (
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/trips" element={<StaffManagement />} />
          <Route path="/trips" element={<StaffManagement />} />
          <Route path="/profile" element={<Profile />} />
          <Route
            path="/addPurchase"
            element={<StaffManagement2 />}
          // element={

          //       <Route path="/staff" />

          // }
          />

          <Route path="/addFuelDetails" element={<AddFuelDetails />} />
          <Route path="/addToMaintenance" element={<AddMaintenance />} />
          <Route path="/viewInMaintenance" element={<TrackMaintenance />} />
          <Route path="/viewTripDetails" element={<TrackVehicle />} />
          <Route path="/viewFuelDetails" element={<TrackFuel />} />
          <Route path="/viewPurchase" element={<TrackFuelPUrchase />} />
          <Route path="/editTrips" element={<EditDetails />} />
          <Route path="/updateTrips" element={<UpdateTripDetails />} />
          <Route path="/editMaintenance" element={<EditMaintenance />} />
          <Route path="/addVehicle" element={<AddVehicleComponent />} />
          <Route path="/viewVehicle" element={<ViewVehicleComponent />} />
          <Route path="/addVendor" element={<AddVendorComponent />} />
          <Route path="/addDriver" element={<AddDriverManagement />} />
          <Route path="/dshbd" element={<DashboardMain />} />
          <Route path="/tabular-report" element={<ReportTabularView />} />

          <Route path="**" element={<StaffManagement />} />
        </Routes>
      ) : (
        <Routes>
          {" "}
          <Route path="/" element={<Login />} />{" "}
          <Route path="/forgot" element={<ForgetPassword />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/forgot-password/:id" element={<ForgetPassword />} />
          <Route path="**" element={<Login />} />{" "}
          <Route path="*/*" element={<Login />} />{" "}
        </Routes>
      )}
    </>
  );
}
